<div class="container">
  <!-- Run/Rerun Diagnostic Button -->
  <button qai-button size="medium" (click)="onRunDiagnosticClick()"
    [kind]="diagnosticResult ? 'tertiary' : 'secondary'"
    [disabled]="isRunningDiagnostic">

    <qai-spinner size="small" positionStart *ngIf="isRunningDiagnostic"></qai-spinner>

    {{
    isRunningDiagnostic
    ? ('settings.DIAGNOSTIC_RUNNING' | transloco)
    : (diagnosticResult
    ? ('settings.RERUN_DIAGNOSTIC' | transloco)
    : ('settings.RUN_DIAGNOSTIC' | transloco))
    }}
  </button>

  <!-- Copy Results Button -->
  <ng-container *ngIf="isDiagnosticComplete && diagnosticResult && !diagnosticResult.hasPassed">
    <button #floatingRef qai-button kind="secondary" size="medium" (click)="onCopyResultsClick()">
      {{'settings.COPY_DIAGNOSTIC_RESULTS' | transloco}}
    </button>

    <qai-tooltip
      [qaiFloating]="floatingRef.elementRef.nativeElement" [placement]="'below-center'" [events]="['click']"
      [style.maxWidth]="'300px'">
      {{'settings.DIAGNOSTIC_RESULTS_COPIED' | transloco}}
    </qai-tooltip>
  </ng-container>

  <!-- Diagnostic running message -->
  <div class="diagnostic-message info-message" *ngIf="isRunningDiagnostic">
    {{'settings.DIAGNOSTIC_RUNNING_MESSAGE' | transloco}}
  </div>

  <!-- Diagnostic result message -->
  <div class="diagnostic-message error-message" *ngIf="isDiagnosticComplete && diagnosticResult && !diagnosticResult.hasPassed">
    <img src="assets/icons/alert-circle.svg" [alt]="('settings.ALERT' | transloco)" class="message-icon">
    {{'settings.DIAGNOSTIC_FAILED_MESSAGE' | transloco}}
  </div>
  <div class="diagnostic-message success-message" *ngIf="isDiagnosticComplete && diagnosticResult && diagnosticResult.hasPassed">
    {{'settings.DIAGNOSTIC_PASSED' | transloco}}
  </div>
</div>